import React from 'react';



const __defaultPageSize = 14;


export interface IListPagePaginationParams {
  first: number;
  after?: string;
}



export interface IUseListPageControl {
  pageSize?: number;
}

export function useListPageControl({
  pageSize
}: {
  pageSize?: number;
}) {
  const [cursor, setCursor] = React.useState('');
  const paginationInput = React.useMemo(
    (): IListPagePaginationParams => ({
      first: pageSize ?? __defaultPageSize,
      after: cursor || undefined
    }),
    [cursor, pageSize]
  );

  return {
    reset: () => {
      setCursor('');
    },
    paginationInput,
    setCursor
  };
}

export type IListPageControl = ReturnType<typeof useListPageControl>;
